const PREFIX = 'APP'

export const APP_INIT = `${PREFIX}_INIT`
export const APP_SHOW_ALERT = `${PREFIX}_SHOW_ALERT`
export const APP_HIDE_ALERT = `${PREFIX}_HIDE_ALERT`
export const APP_SET_SESSION_ID = `${PREFIX}_SET_SESSION_ID`
export const APP_SEARCH_CLEAR = `${PREFIX}_SEARCH_CLEAR`
export const APP_SEARCH_SET = `${PREFIX}_SEARCH_SET`
export const APP_CACHE_FILTERS = `${PREFIX}_CACHE_FILTERS`

export const APP_SORT_LIST = `${PREFIX}_SORT_LIST`
export const APP_SORT_LOADING = `${PREFIX}_SORT_LOADING`

export const APP_POST_RATING = `${PREFIX}_POST_RATING`
export const APP_POST_RATING_LOADING = `${PREFIX}_POST_RATING_LOADING`
export const APP_POST_RATING_ERROR = `${PREFIX}_POST_RATING_ERROR`

export const APP_PAGE_TITLE = `${PREFIX}_PAGE_TITLE`
export const APP_OTHER_PROFILE_ACCESS = `${PREFIX}_OTHER_PROFILE_ACCESS`
